webpackJsonp([96961042003272],{

/***/ 1279:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1246:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	__webpack_require__(1279);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageBody = function PageBody(props) {
	  var thisHtml = '';
	  if (props.body !== null) {
	    thisHtml = props.body.childMarkdownRemark.html;
	  }
	
	  return _react2.default.createElement("div", {
	    className: (0, _classnames2.default)(props.classes.post, props.className),
	    dangerouslySetInnerHTML: { __html: thisHtml }
	  });
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  return {
	    post: {
	      width: "100%",
	      color: "#413F48",
	      fontSize: "18px",
	      lineHeight: "1.6",
	      margin: "48px auto 16px auto",
	
	      "& h1": {
	        color: "#2E2E35",
	        fontWeight: "700",
	        letterSpacing: ".2px",
	        lineHeight: "1.2",
	        fontSize: "24px",
	        marginTop: "44px",
	        marginBottom: "12px"
	      },
	
	      "& h2": {
	        fontSize: "22px",
	        lineHeight: "1.4",
	        fontWeight: "700",
	        marginTop: "32px",
	        marginBottom: "12px"
	      },
	
	      "& h3": {
	        fontSize: "20px",
	        fontWeight: "700",
	        marginTop: "32px",
	        marginBottom: "12px"
	      },
	
	      "& h4": {
	        fontSize: "18px",
	        fontWeight: "600",
	        marginTop: "24px",
	        marginBottom: "12px"
	      },
	
	      "& a": {
	        color: "#2E2E35",
	        textDecoration: "underline"
	      },
	
	      "& em": {
	        fontStyle: "italic"
	      },
	
	      "& strong": {
	        fontWeight: "700"
	      },
	
	      "& ol": {
	        position: "relative",
	        counterReset: "item"
	      },
	
	      "& ol li": {
	        counterIncrement: "item",
	        paddingLeft: "24px",
	
	        "&:before": {
	          content: 'counter(item) "."',
	          position: "absolute",
	          left: "0",
	          fontWeight: "700"
	        }
	      },
	
	      "& ul": {
	        listStyleType: "disc"
	      },
	
	      "& ul li": {
	        marginLeft: "18px"
	      },
	
	      "& p": {
	        marginTop: "4px",
	        marginBottom: "8px"
	      },
	
	      "& img": {
	        display: "block",
	        maxWidth: "100%",
	        marginBottom: "16px"
	      }
	    }
	  };
	})(PageBody);
	module.exports = exports["default"];

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageTitle = function PageTitle(_ref) {
	  var children = _ref.children,
	      classes = _ref.classes,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    "div",
	    { className: (0, _classnames2.default)(classes.root, className) },
	    children
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  var _root;
	
	  return {
	    root: (_root = {
	      width: "100%",
	      lineHeight: "1.2",
	      fontSize: "28px",
	      color: "#2E2E35",
	      fontWeight: "800",
	      marginBottom: "32px"
	
	    }, _root[theme.breakpoints[600]] = {
	      fontSize: "36px"
	    }, _root)
	  };
	})(PageTitle);
	module.exports = exports["default"];

/***/ }),

/***/ 1753:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _siteConfig = __webpack_require__(7);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _Container = __webpack_require__(5);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _PageTitle = __webpack_require__(159);
	
	var _PageTitle2 = _interopRequireDefault(_PageTitle);
	
	var _PageBody = __webpack_require__(1246);
	
	var _PageBody2 = _interopRequireDefault(_PageBody);
	
	var _SEO = __webpack_require__(6);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageTemplate = function PageTemplate(_ref) {
	  var classes = _ref.classes,
	      contentfulPage = _ref.data.contentfulPage;
	  var title = contentfulPage.title,
	      slug = contentfulPage.slug,
	      body = contentfulPage.body,
	      body2 = contentfulPage.body2;
	
	  var postNode = contentfulPage;
	
	  return _react2.default.createElement(
	    "div",
	    { className: classes.root },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        "title",
	        null,
	        title + " - " + _siteConfig2.default.siteTitle
	      )
	    ),
	    _react2.default.createElement(_SEO2.default, { pagePath: slug, postNode: postNode, pageSEO: true }),
	    _react2.default.createElement(
	      _Container2.default,
	      null,
	      _react2.default.createElement(
	        _PageTitle2.default,
	        null,
	        title
	      ),
	      _react2.default.createElement(_PageBody2.default, { body: body }),
	      _react2.default.createElement(_PageBody2.default, { body: body2 })
	    )
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  return {
	    root: {
	      display: "flex",
	      flexDirection: "column",
	      width: "100%",
	      padding: "0 8px",
	      margin: "72px auto 96px auto"
	    }
	  };
	})(PageTemplate);

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-page-js-0e3e590144edce08343f.js